import { ChangeDetectorRef, Component, Input, SimpleChanges } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';

@Component({
  selector: 'app-all-data-view-items',
  templateUrl: './all-data-view-items.component.html',
  styleUrl: './all-data-view-items.component.scss'
})
export class AllDataViewItemsComponent {
  isObject(arg0: any): boolean {
    return !Array.isArray(arg0)
  }
  getIcon(arg0: unknown) {
    return arg0 as string
  }
  converttostring(arg0: unknown): string {
    let res = arg0 as string

    return res;
  }
  isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || "false");
  layout: string = 'grid';



  @Input() filterItems!: any[]

  @Input() type: string = "جميع الكيانات والوزارات";

  @Input() gotoLink: string = '/all-data-view'

  @Input() datatype: string = 'service'

  siteUrl = GlobalConstants.staticFilesURL;

  filterText: string = '';
  notObject: any = {
    name: "notObject",
    image: "pi pi-times"
  };



  constructor(private cdr: ChangeDetectorRef,
    private dataService: DataService,
    private permissionService: PermissionHandlerService
  ) {
  }

  @Input() items: any[] = [];
  @Input() object: any;
  notcountedItems: any[] = [];

  sequence: string[] = ["الخدمات", "الأسئلة الشائعة"];

  getSortedDataCounter(item: any): Record<string, number> {
    const dataCounter = item.data_counter || {};
    return Object.entries(dataCounter)
      .sort(([keyA], [keyB]) => {
        const indexA = this.sequence.indexOf(keyA);
        const indexB = this.sequence.indexOf(keyB);
        return indexA - indexB;
      })
      .reduce((acc: any, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {});
  }

  dataTypes: any = {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['object'] && changes['object'].currentValue) {
      console.log('ngOnChanges: object changed');
      this.ngAfterViewInit();
    }
  }

  ngOnInit(): void {
    this.getDataTypes().then((data: any) => {
      data.forEach((item: { arabic: string | number; icon: any; }) => {
        this.dataTypes[item.arabic] = item.icon;
      });
    })
    console.log('ngOnInit');
  }


  checkOuIdExists(id: string) {
    return this.permissionService.payload.dataView.signedOus.includes(id)
  }

  checkDataCountValues(data: any) {
    if (this.isLoggedIn) {
      return true;
    } else {

      if(!!data && this.checkOuIdExists(data._id)) {
        return (Object.values(data) as number[]).reduce((a, b) => a + b, 0) > 0
      }
      
      return true;
    }
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit');

    if (this.object && this.items) {
      this.filterItems = this.items;
    }

    this.filterText = '';

    //this.applyFilter()
  }


  //Image if its image or icon
  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  // Create a method to check if an item with a specific ID and 'ous' property exists
  itemHasOus(id: number, ous: number[]): boolean {
    return ous.includes(id);
  }

  applyFilter() {
    if (this.filterText) {
      // Filter items based on the filterText
      this.filterItems = this.filterItems.filter(item =>
        item.name.toLowerCase().includes(this.filterText.toLowerCase())
      );
    } else {
      // Reset the items to the original data source
      this.filterItems = this.items; // originalItems should be your unfiltered data source
    }

  }

  async getDataTypes() {
    let res = await this.dataService.postData('data-type/get?offset=10&page=1', {});

    return res.data;
  }



  consoleThis() {
    console.log("< service view >")
  }

  applyNotObject() {
    this.filterItems = this.notcountedItems
  }

  dataSorter(dataCounter: any[]): any[] {
    const orderArray = ["الخدمات", "الأسئلة الشائعة"];

    if (dataCounter) {

      // Sort the dataCounter array
      dataCounter.sort((a, b) => {
        const aIndex = orderArray.indexOf(a._id);
        const bIndex = orderArray.indexOf(b._id);

        // If both items are in the orderArray, sort based on their order
        if (aIndex !== -1 && bIndex !== -1) {
          return aIndex - bIndex;
        }

        // If only one of the items is in the orderArray, it comes first
        if (aIndex !== -1) {
          return -1;
        }
        if (bIndex !== -1) {
          return 1;
        }

        // If neither item is in the orderArray, sort them by their _id
        return a._id.localeCompare(b._id);
      });

    }


    return dataCounter; // Return the sorted array
  }

}
